import {ActionType, createAction, props} from '@ngrx/store';
import {ItemsReq,} from '../../models';

export const APP_FILTER = '@App/filter';

export const StoreFilterState = createAction(
  APP_FILTER,
  props<{
    payload: ItemsReq;
  }>()
);

export type FilterActions = ActionType<typeof StoreFilterState>;
